(
    function (skyward, $)
    {
        skyward.reporting = skyward.reporting || {};
        skyward.reporting.userCondition = skyward.reporting.userCondition || {};

        //TODO: until PR 5918928 updates to user conditions will also need to consider reportDefinitionViewer\shared.tsx
        skyward.reporting.userCondition.init = function (userConditionWrapper)
        {
            const wrapperElement = userConditionWrapper;

            const leftOperandElement = wrapperElement.find('.userConditionValueSelectorDisplay.leftOperand');
            const rightOperandElement = wrapperElement.find('.userConditionValueSelectorDisplay.rightOperand');

            const booleanConditionElement = wrapperElement.find('.booleanConditionComboBox');
            const conditionElement = wrapperElement.find('.conditionTypeSelector');

            //Public
            function getPromptDataFromPrompt(valueBox, promptContainer)
            {
                const promptLabel = promptContainer.find(".promptLabel");
                let name = promptLabel.val();

                if (!name || !name.length)
                {
                    name = "Prompt";
                }
                return buildPromptData(valueBox, name);
            }

            //Public
            function getPromptData(valueBox, currentColumn, currentRow, currentSection)
            {
                let name;
                if (currentColumn)
                {
                    name = currentColumn.data("designerText");
                }
                else
                {
                    name = currentSection.data("displayName");
                    if (!currentRow.hasClass("sectionToolbar"))
                    {
                        name = name ? name + " " + currentRow.data("reportLabelText") : currentRow.data("reportLabelText");
                    }
                }

                return buildPromptData(valueBox, name);
            }

            function buildPromptData(valueBox, name)
            {
                const result = {};

                result.Label = "Hide " + name;
                if (valueBox.hasClass("rightOperand"))
                {
                    const leftOperandElementData = leftOperandElement.data();
                    result.InputType = leftOperandElementData.fieldType;
                    result.SpecificTypeRequired = true;

                    if (leftOperandElementData.sectionIDHasAnyDetailRows)
                    {
                        result.Label += " When Detail Sections Have Any Rows"
                    }
                }
                else
                {
                    result.InputType = "Boolean";
                }
                result.PresenceType = "Required";

                return result;
            }

            function getRightOperandClassSelectorForType(dataType, isCustomPrompt)
            {
                let classSelector;

                if (isCustomPrompt || dataType === "Prompt" || dataType === "Column" || dataType.startsWith("String Enum"))
                {
                    classSelector = ".userConditionValueSelectorDisplay";
                }
                else if (dataType.startsWith("Number"))
                {
                    if (dataType == "Number Decimal")
                    {
                        classSelector = ".decimalValueSelector";
                    }
                    else
                    {
                        classSelector = ".numericValueSelector";
                    }
                }
                else if (dataType === "Boolean")
                {
                    classSelector = ".booleanValueSelector";
                }
                else if (dataType === "DateTime")
                {
                    classSelector = ".dateValueSelector";
                }
                else if (dataType === "TimeSpan")
                {
                    classSelector = ".timeSpanValueSelector";
                }
                else if (dataType == "Time")
                {
                    classSelector = ".timeValueSelector";
                }
                else if (dataType === "String")
                {
                    classSelector = ".stringValueSelector";
                }
                return classSelector;
            }

            function defaultRightOperandInputIfEmpty(dataType, element)
            {
                if (!skyward.controls.getValue(element))
                {
                    let defaultValue = "";
                    if (dataType.startsWith("Number"))
                    {
                        defaultValue = 0;
                    }
                    else if (dataType === "Boolean")
                    {
                        defaultValue = "True";
                    }
                    skyward.controls.setValue(element, defaultValue, true);
                }
            }

            function getRightOperandInputElementForType(dataType, isCustomPrompt)
            {
                return wrapperElement.find(getRightOperandClassSelectorForType(dataType, isCustomPrompt)).find(".isHiddenValueSelector").addBack(".isHiddenValueSelector");
            }

            function getRightOperandDisplayElementForType(dataType, isCustomPrompt)
            {
                return wrapperElement.find(getRightOperandClassSelectorForType(dataType, isCustomPrompt)).find(".isHiddenValueDisplay").addBack(".isHiddenValueDisplay");
            }

            function showRightOperandInputForType(dataType, isCustomPrompt)
            {
                const rightOperands = wrapperElement.find(".rightOperandOptions");
                rightOperands.each(function ()
                {
                    skyward.controls.show($(this), false);
                });

                const valueSelectors = rightOperands.find(".isHiddenValueDisplay");
                valueSelectors.each(function ()
                {
                    skyward.controls.hide($(this), false);
                });

                skyward.controls.show(getRightOperandDisplayElementForType(dataType, isCustomPrompt), false);
            }

            //Public
            function setIsHiddenCondition(isHiddenCondition, selectedName, getSvgByDataTypeFunction, selectedColumnID, getColumnLabelMethod)
            {
                wrapperElement.find(".selectedName").text(selectedName);
                leftOperandElement.removeData();
                rightOperandElement.removeData();

                if (isHiddenCondition && isHiddenCondition.LeftOperand && isHiddenCondition.RightOperand)
                {
                    const promptLeft = skyward.reporting.prompts.promptCollection.Get(isHiddenCondition.LeftOperand.PromptUniqueID);
                    const calculatedFieldLeft = skyward.reporting.calculatedFields.Get(isHiddenCondition.LeftOperand.CalculatedFieldGuid);
                    const fieldPathLeft = isHiddenCondition.LeftOperand.FieldPath;
                    const boolValueLeft = isHiddenCondition.LeftOperand.Value;
                    const columnIDLeft = isHiddenCondition.LeftOperand.ColumnID;
                    const dataTypeLeft = isHiddenCondition.LeftOperand.DataType;
                    const displayNameLeft = isHiddenCondition.LeftOperand.DisplayName;
                    const isCustomPromptLeft = promptLeft != null && promptLeft.Type === skyward.reporting.enummaps.PromptTypes.CustomSingleSelect;
                    const sectionIDHasAnyDetailRowsLeft = isHiddenCondition.LeftOperand.SectionIDHasAnyDetailRows;
                    const parametersLeft = isHiddenCondition.LeftOperand.Parameters;
                    const isCalculatedLeft = isHiddenCondition.LeftOperand.IsCalculated;
                    const isOperationLeft = isHiddenCondition.LeftOperand.IsOperation;

                    const promptRight = skyward.reporting.prompts.promptCollection.Get(isHiddenCondition.RightOperand.PromptUniqueID);
                    const calculatedFieldRight = skyward.reporting.calculatedFields.Get(isHiddenCondition.RightOperand.CalculatedFieldGuid);
                    const fieldPathRight = isHiddenCondition.RightOperand.FieldPath;
                    const columnIDRight = isHiddenCondition.RightOperand.ColumnID;
                    const dataTypeRight = isHiddenCondition.RightOperand.DataType;
                    const displayNameRight = isHiddenCondition.RightOperand.DisplayName;
                    const parametersRight = isHiddenCondition.RightOperand.Parameters;
                    const isCalculatedRight = isHiddenCondition.RightOperand.IsCalculated;
                    const isOperationRight = isHiddenCondition.RightOperand.IsOperation;

                    leftOperandElement.empty();
                    rightOperandElement.empty();
                    const svgLeft = getSvgByDataTypeFunction(dataTypeLeft, "TreeBrowse");
                    const svgRight = getSvgByDataTypeFunction(dataTypeRight, "TreeBrowse");

                    if (columnIDRight == undefined && promptRight == undefined && fieldPathRight == undefined)
                    {
                        showRightOperandInputForType(dataTypeRight, isCustomPromptLeft);
                    }
                    else if (columnIDRight != undefined || fieldPathRight != undefined)
                    {
                        showRightOperandInputForType("Column", isCustomPromptLeft);
                    }
                    else
                    {
                        showRightOperandInputForType("Prompt", isCustomPromptLeft);
                    }

                    const leftValue =
                    {
                        prompt: promptLeft,
                        calculatedField: calculatedFieldLeft,
                        columnID: columnIDLeft,
                        fieldPath: fieldPathLeft,
                        boolValue: boolValueLeft,
                        sectionIDHasAnyDetailRows: sectionIDHasAnyDetailRowsLeft,
                        displayName: displayNameLeft,
                        dataType: dataTypeLeft,
                        parameters: parametersLeft,
                        isCalculated: isCalculatedLeft,
                        isOperation: isOperationLeft
                    }

                    setOperandValues(selectedColumnID, leftOperandElement, isHiddenCondition.LeftOperand, svgLeft, leftValue, getColumnLabelMethod);

                    leftOperandElement.data("fieldType", dataTypeLeft);

                    const rightValue =
                    {
                        prompt: promptRight,
                        calculatedField: calculatedFieldRight,
                        columnID: columnIDRight,
                        fieldPath: fieldPathRight,
                        boolValue: null,
                        displayName: displayNameRight,
                        dataType: dataTypeRight,
                        parameters: parametersRight,
                        isCalculated: isCalculatedRight,
                        isOperation: isOperationRight
                    }

                    setOperandValues(selectedColumnID, rightOperandElement, isHiddenCondition.RightOperand, svgRight, rightValue, getColumnLabelMethod);

                    rightOperandElement.data("fieldType", dataTypeRight);

                    if (useBooleanConditionElement(dataTypeLeft))
                    {
                        booleanConditionElement.val(isHiddenCondition.Condition);
                    }
                    else
                    {
                        conditionElement.val(isHiddenCondition.Condition);
                    }

                    if (isHiddenCondition.RightOperand.Value != null)
                    {
                        if (isCustomPromptLeft)
                        {
                            const customValue = isHiddenCondition.RightOperand.Value;
                            const customDisplayValue = promptLeft.getSelectionOptionDisplayValueByKey(customValue) ?? customValue;
                            rightOperandElement.data("customValue", customValue);
                            rightOperandElement.data("customDisplayValue", customDisplayValue);
                            rightOperandElement.text(customDisplayValue);
                        }
                        else if (isHiddenCondition.RightOperand.DataType.startsWith("String Enum"))
                        {
                            rightOperandElement.data("enumValue", isHiddenCondition.RightOperand.Value);
                            rightOperandElement.data("enumDisplayValue", isHiddenCondition.RightOperand.EnumDisplayValue);
                            rightOperandElement.text(isHiddenCondition.RightOperand.EnumDisplayValue);
                        }
                        else
                        {
                            const rightOperandSelector = getRightOperandInputElementForType(dataTypeLeft, isCustomPromptLeft);
                            skyward.controls.setValue(rightOperandSelector, isHiddenCondition.RightOperand.Value, true);
                        }
                    }

                    toggleConditionsForType(dataTypeLeft);
                }
                else
                {
                    wrapperElement.find(".rightOperandOptions").hide();

                    leftOperandElement.data("promptUniqueId", null);
                    leftOperandElement.data("calculatedFieldName", null);
                    leftOperandElement.data("fieldName", null);
                    leftOperandElement.data("boolvalue", false);
                    leftOperandElement.text("False");
                    leftOperandElement.data("displayName", null);
                    leftOperandElement.data("dataType", null);
                    leftOperandElement.data("parameters", null);
                    leftOperandElement.data("displayName", null);
                    leftOperandElement.data("isCalculated", null);
                    leftOperandElement.data("isOperation", null);

                    conditionElement.val("EqualTo");
                    booleanConditionElement.val("EqualTo");

                    clearIsHiddenValueSelectors();
                    rightOperandElement.data("promptUniqueId", null);
                    rightOperandElement.data("calculatedFieldName", null);
                    rightOperandElement.data("enumValue", null);
                    rightOperandElement.data("customValue", null);
                    rightOperandElement.data("fieldName", null);
                    rightOperandElement.data("boolvalue", false);
                    rightOperandElement.text("False");
                    rightOperandElement.data("displayName", null);
                    rightOperandElement.data("dataType", null);
                    rightOperandElement.data("parameters", null);
                    rightOperandElement.data("isCalculated", null);
                    rightOperandElement.data("isOperation", null);
                }
            }

            function setOperandValues(selectedColumnID, operandEditor, operand, svg, valueCollection, getColumnLabelMethod)
            {
                if (valueCollection.prompt)
                {
                    setIsHiddenOperandPrompt(valueCollection.prompt, operandEditor);
                }
                else if (valueCollection.calculatedField)
                {
                    operandEditor.html(svg).append(document.createTextNode(valueCollection.calculatedField.fieldName));
                    operandEditor.data("calculatedFieldName", valueCollection.calculatedField.id);
                }
                else if (valueCollection.columnID)
                {
                    let columnLabel = "Current Column Value";
                    if (selectedColumnID != valueCollection.columnID)
                    {
                        columnLabel = getColumnLabelMethod(valueCollection.columnID);
                    }

                    operandEditor.html(document.createTextNode(columnLabel));
                    operandEditor.data("columnId", valueCollection.columnID);
                }
                else if (valueCollection.fieldPath)
                {
                    operandEditor.html(svg).append(document.createTextNode(operand.FieldDisplayText));
                    operandEditor.data("fieldName", valueCollection.fieldPath);
                }
                else if (valueCollection.boolValue != null)
                {
                    wrapperElement.find(".rightOperandOptions").hide();
                    const boolValueString = valueCollection.boolValue.toString().capitalize();

                    operandEditor.html(document.createTextNode(boolValueString));
                    operandEditor.data("boolvalue", valueCollection.boolValue);
                }
                else if (valueCollection.sectionIDHasAnyDetailRows)
                {
                    operandEditor.html(svg).append(document.createTextNode("Detail Sections Have Any Rows"));
                    operandEditor.data("sectionIdHasAnyDetailRows", valueCollection.sectionIDHasAnyDetailRows);
                }

                operandEditor.data("displayName", valueCollection.displayName);
                operandEditor.data("dataType", valueCollection.dataType);
                operandEditor.data("parameters", valueCollection.parameters);
                operandEditor.data("isCalculated", valueCollection.isCalculated);
                operandEditor.data("isOperation", valueCollection.isOperation);
            }

            //Public
            function setIsHiddenOperandPrompt(prompt, operandEditor)
            {
                const svg = skyward.svg.getSvg(prompt.getIconType(), "TreeBrowse");
                operandEditor.html(svg).append(document.createTextNode(prompt.Label));
                operandEditor.data("promptUniqueId", prompt.PromptUniqueId);
            }

            function getAlwaysTrueCondition()
            {
                return {
                    Condition: "EqualTo",
                    LeftOperand: {
                        Value: true,
                        DataType: "Boolean"
                    },
                    RightOperand: {
                        Value: true,
                        DataType: "Boolean"
                    }
                };
            }

            //Public
            function getUpdatedIsHiddenCondition()
            {
                const leftOperandElementData = leftOperandElement.data();
                const rightOperandElementData = rightOperandElement.data();

                const promptUniqueIDLeft = leftOperandElementData.promptUniqueId;
                const calculatedFieldGuidLeft = leftOperandElementData.calculatedFieldName;
                const fieldPathLeft = leftOperandElementData.fieldName;
                const boolValueLeft = leftOperandElementData.boolvalue;
                const columnIDLeft = leftOperandElementData.columnId;
                const promptLeft = skyward.reporting.prompts.promptCollection.Get(promptUniqueIDLeft);
                const isCustomPromptLeft = promptLeft != null && promptLeft.Type === skyward.reporting.enummaps.PromptTypes.CustomSingleSelect;
                const sectionIdHasAnyDetailRowsLeft = leftOperandElementData.sectionIdHasAnyDetailRows;
                const displayNameLeft = leftOperandElementData.displayName;
                const parametersLeft = leftOperandElementData.parameters;
                const isCalculatedLeft = leftOperandElementData.isCalculated;
                const isOperationLeft = leftOperandElementData.isOperation;

                const promptUniqueIDRight = rightOperandElementData.promptUniqueId;
                const calculatedFieldGuidRight = rightOperandElementData.calculatedFieldName;
                const fieldPathRight = rightOperandElementData.fieldName;
                const columnIDRight = rightOperandElementData.columnId;
                const displayNameRight = rightOperandElementData.displayName;
                const parametersRight = rightOperandElementData.parameters;
                const isCalculatedRight = rightOperandElementData.isCalculated;
                const isOperationRight = rightOperandElementData.isOperation;

                if (boolValueLeft === false)
                {
                    return null;
                }

                if (boolValueLeft === true)
                {
                    return getAlwaysTrueCondition();
                }

                let isHiddenCondition =
                {
                    Condition: null,
                    LeftOperand: {},
                    RightOperand: {}
                };

                const leftOperandDataType = leftOperandElement.data("fieldType");
                const leftOperandText = leftOperandElement.text();
                const leftOperandValues =
                {
                    columnID: columnIDLeft,
                    promptUniqueID: promptUniqueIDLeft,
                    calculatedFieldGuid: calculatedFieldGuidLeft,
                    fieldPath: fieldPathLeft,
                    value: null,
                    enumDisplayValue: null,
                    sectionIdHasAnyDetailRows: sectionIdHasAnyDetailRowsLeft,
                    displayName: displayNameLeft,
                    parameters: parametersLeft,
                    isCalculated: isCalculatedLeft,
                    isOperation: isOperationLeft
                };
                const clearHiddenCondtion = updateOperandCondition(isHiddenCondition.LeftOperand, leftOperandDataType, leftOperandText, leftOperandValues);

                if (clearHiddenCondtion)
                {
                    return null;
                }

                const rightOperandText = rightOperandElement.text();

                //skyward.controls.getValue encodes the value and we do not want an encoded value here.
                //The value will be encoded when the definition json gets posted.
                let rightValue = rightOperandElementData.enumValue ??
                    rightOperandElementData.customValue ??
                    skyward.controls.getUnencodedValue(getRightOperandInputElementForType(isHiddenCondition.LeftOperand.DataType, isCustomPromptLeft));

                const rightOperandValues =
                {
                    columnID: columnIDRight,
                    promptUniqueID: promptUniqueIDRight,
                    calculatedFieldGuid: calculatedFieldGuidRight,
                    fieldPath: fieldPathRight,
                    value: rightValue,
                    enumDisplayValue: rightOperandElementData.enumDisplayValue,
                    displayName: displayNameRight,
                    parameters: parametersRight,
                    isCalculated: isCalculatedRight,
                    isOperation: isOperationRight
                };

                updateOperandCondition(isHiddenCondition.RightOperand, isHiddenCondition.LeftOperand.DataType, rightOperandText, rightOperandValues);

                isHiddenCondition.Condition = useBooleanConditionElement(isHiddenCondition.LeftOperand.DataType) ? booleanConditionElement.val() : conditionElement.val();

                return isHiddenCondition;
            }

            function updateOperandCondition(operand, dataType, text, values)
            {
                operand.DataType = dataType;
                operand.DisplayName = values.displayName;
                operand.Parameters = values.parameters ?? [];
                operand.IsCalculated = values.isCalculated ?? false;
                operand.IsOperation = values.isOperation ?? false;

                if (values.columnID)
                {
                    operand.ColumnID = values.columnID;
                }
                else if (values.promptUniqueID)
                {
                    const prompt = skyward.reporting.prompts.promptCollection.Get(values.promptUniqueID);
                    operand.PromptUniqueID = values.promptUniqueID;
                    operand.DataType = prompt.InputType;
                }
                else if (values.calculatedFieldGuid)
                {
                    const calculatedField = skyward.reporting.calculatedFields.Get(values.calculatedFieldGuid);
                    operand.CalculatedFieldGuid = values.calculatedFieldGuid;
                    operand.DataType = calculatedField.dataType;
                }
                else if (values.fieldPath)
                {
                    operand.FieldPath = values.fieldPath;
                    operand.FieldDisplayText = text;
                }
                else if (values.value || (dataType == "String" && values.value === ""))
                {
                    operand.Value = values.value;

                    if (values.enumDisplayValue)
                    {
                        operand.EnumDisplayValue = values.enumDisplayValue;
                    }
                }
                else if (values.sectionIdHasAnyDetailRows)
                {
                    operand.SectionIDHasAnyDetailRows = values.sectionIdHasAnyDetailRows;
                }
                else
                {
                    return true;
                }

                return false;
            }

            function clearIsHiddenValueSelectors()
            {
                wrapperElement.find(".isHiddenValueSelector").each(function ()
                {
                    skyward.controls.setValue($(this), "", true);
                });
                skyward.controls.setValue(wrapperElement.find(".booleanValueSelector"), "True", true);
            }

            function useBooleanConditionElement(dataType)
            {
                return dataType === "Boolean" || dataType.startsWith("String Enum");
            }

            function toggleConditionsForType(dataType)
            {
                if (useBooleanConditionElement(dataType))
                {
                    conditionElement.hide();
                    booleanConditionElement.show();
                }
                else
                {
                    conditionElement.show();
                    booleanConditionElement.hide();
                }
            }

            //Public
            function isConditionAlwaysHidden(isHiddenCondition)
            {
                if (isHiddenCondition == null)
                {
                    return false;
                }
                return isOperandTrue(isHiddenCondition.LeftOperand) && isOperandTrue(isHiddenCondition.RightOperand)
            }

            //Public
            function isConditionAlwaysDisplayed(isHiddenCondition)
            {
                if (isHiddenCondition == null)
                {
                    return true;
                }
                return isOperandFalse(isHiddenCondition.LeftOperand) && isOperandTrue(isHiddenCondition.RightOperand)
            }

            function isOperandTrue(operand)
            {
                if (operand == null)
                {
                    return false;
                }
                return operand.DataType === "Boolean" && String(operand.Value).toLowerCase() === "true";
            }

            function isOperandFalse(operand)
            {
                if (operand == null)
                {
                    return false;
                }
                return operand.DataType === "Boolean" && String(operand.Value).toLowerCase() === "false";
            }

            //Public
            function getUserConditionOperandFilterValueSelector(button, allowOptions, columns, prompts, dataType, columnDataType, useVisibleCondition, valueSelectorClickEvents, leftPromptUniqueID = null, currentSectionID = null)
            {
                const requestingButton = $(button);
                const findConditon = useVisibleCondition ? ".conditionValue:visible" : ".conditionValue";
                const valueBox = requestingButton.closest(".conditionValuesContainer").find(findConditon);

                $.ajax({
                    url: skyward.global.virtualDir + "Reporting/Report/GetUserConditionOperandSelector",
                    type: "POST",
                    dataType: "JSON",
                    data: {
                        currentPromptsJson: skyward.extensions.encodeHtml(JSON.stringify(prompts)),
                        allowPrompts: allowOptions.prompts,
                        allowFieldSelection: allowOptions.fieldSelection,
                        allowCurrentColumnValue: allowOptions.currentColumnValue,
                        columnsJson: JSON.stringify(columns),
                        dataType: dataType,
                        allowAlwaysHidden: allowOptions.alwaysHidden,
                        columnDataType: columnDataType,
                        leftPromptUniqueID: leftPromptUniqueID,
                        allowDetailSectionsHaveAnyRows: allowOptions.detailSectionsHaveAnyRows,
                        currentSectionID: currentSectionID,
                    },
                    success: async function (data)
                    {
                        const processedHtml = await skyward.global.processViewPartHtml(data.html);
                        skyward.filterbuilder.openValueSelector(processedHtml, button, valueBox, false, false, valueSelectorClickEvents);
                    }
                });
            };

            return {
                setIsHiddenCondition: setIsHiddenCondition,
                setIsHiddenOperandPrompt: setIsHiddenOperandPrompt,
                getUpdatedIsHiddenCondition: getUpdatedIsHiddenCondition,
                isConditionAlwaysHidden: isConditionAlwaysHidden,
                isConditionAlwaysDisplayed: isConditionAlwaysDisplayed,
                getPromptData: getPromptData,
                getPromptDataFromPrompt: getPromptDataFromPrompt,
                getUserConditionOperandFilterValueSelector: getUserConditionOperandFilterValueSelector,
                elements: {
                    wrapper: wrapperElement,
                    left: leftOperandElement,
                    right: rightOperandElement,
                    boolCondition: booleanConditionElement,
                    condition: conditionElement
                }
            }
        };

    }(window.skyward = window.skyward || {}, window.jQuery)
);